import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const headerStyle = css`
  padding: ${theme.spacing(2)};
  gap: ${theme.spacing(1)};
  display: flex;
  align-items: center;
  border-top: 1px solid ${theme.colors.neutral10};
  border-bottom: 1px solid ${theme.colors.neutral10};
`;

export const taskTitleContainer = css`
  display: flex;
  gap: ${theme.spacing(1)};
  justify-content: space-between;
  padding-bottom: ${theme.spacing(2)};
`;

export const taskDescriptionStyle = css`
  border-bottom: 1px solid ${theme.colors.neutral20};
  padding-bottom: ${theme.spacing(3)};
  margin-bottom: ${theme.spacing(2)};
`;

export const taskDetailsContainer = css`
  padding: ${theme.spacing(2, 3)};
  flex: 1;
  overflow: auto;
`;

export const taskHeaderStyle = css`
  width: fit-content;
  flex-basis: 0;
  flex-grow: 1;
`;
